import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
import LandingPartnerSlider from '@/shared/ui/landing/LandingPartnerSlider.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPartnersSection',
  props: {
    title: null,
    text: null,
    items: null
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'LandingPartnersSection'
    });
    return {
      __sfc: true,
      LandingPartnerSlider: LandingPartnerSlider
    };
  }
});